export default __webpack_public_path__ + "static/media/logoE4Keys.00703edb.png";